const metabolites_sp = {
    'acetate_sp': {
        'Akkermansia muciniphila': 0.5,
        'Alistipes putredinis': 1,
        'Bacteroides genus': 1,
        'Bacteroides fragilis': 0.5,
        'Faecalibacterium prausnitzii': 1,
        'Roseburia hominis': 0.5,
        'Bifidobacterium bifidum': 1,
        'Bifidobacterium breve': 1,
        'Bifidobacterium lactis': 1,
        'Bifidobacterium longum': 1,
        'Lactobacillus acidophilus': 0.25,
        'Lactobacillus gasseri': 0.25,
        'Lactobacillus helveticus': 0.25,
        'Lactobacillus paracasei': 0.25,
        'Lactobacillus plantarum': 0.25,
        'Lactobacillus reuteri': 0.25,
        'Lactobacillus rhamnosus': 0.25,
        'Streptococcus thermophilus': 0.25
    },
    'propionate_sp': {
        'Akkermansia muciniphila': 0.5,
        'Alistipes putredinis': 1,
        'Bacteroides genus': 1,
        'Bacteroides fragilis': 1,
        'Faecalibacterium prausnitzii': 0,
        'Roseburia hominis': 0.5,
        'Bifidobacterium bifidum': 0.25,
        'Bifidobacterium breve': 0.25,
        'Bifidobacterium lactis': 0.25,
        'Bifidobacterium longum': 0.25,
        'Lactobacillus acidophilus': 1,
        'Lactobacillus gasseri': 1,
        'Lactobacillus helveticus': 1,
        'Lactobacillus paracasei': 1,
        'Lactobacillus plantarum': 1,
        'Lactobacillus reuteri': 1,
        'Lactobacillus rhamnosus': 1,
        'Streptococcus thermophilus': 1
    },
    'butyrate_sp': {
        'Akkermansia muciniphila': 0,
        'Alistipes putredinis': 0,
        'Bacteroides genus': 0.5,
        'Bacteroides fragilis': 1,
        'Faecalibacterium prausnitzii': 1,
        'Roseburia hominis': 1,
        'Bifidobacterium bifidum': 0.5,
        'Bifidobacterium breve': 0.5,
        'Bifidobacterium lactis': 0.5,
        'Bifidobacterium longum': 0.5,
        'Lactobacillus acidophilus': 1,
        'Lactobacillus gasseri': 1,
        'Lactobacillus helveticus': 1,
        'Lactobacillus paracasei': 1,
        'Lactobacillus plantarum': 1,
        'Lactobacillus reuteri': 1,
        'Lactobacillus rhamnosus': 1,
        'Streptococcus thermophilus': 1
    }
}

const metabolites_multi = {
    case1: {
        score_cal: 3,
        multiply: 1
    },
    case2: {
        score_cal: 2,
        multiply: 0.5
    },
    case3: {
        score_cal: 1,
        multiply: 0.25
    },
    othercase: {
        multiply: 0
    },
}

const metabolites_spCondition = {
    acetate: {
        page: 40,
        XposText: 503,
        YposText: 459,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 67,
        YposImage: 417,
        xBarStart: 161,
        YBarStart: 465,
        xBarGap: 64,
        yOffset: 200,
        conditions: [
            {
                condition: (x) => x >= 7.35,
                score: 3,
                label: 'Optimum',
                image: 'ac3',
            },
            {
                condition: (x) => (3 < x) && (x < 7.35),
                score: 2,
                label: 'Slightly below optimum',
                image: 'ac2',
            },
            {
                condition: (x) => x <= 3,
                score: 1,
                label: 'Below optimum',
                image: 'ac1',
            }
        ]
    },
    propionate: {
        page: 40,
        XposText: 503,
        YposText: 583,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 67,
        YposImage: 537,
        xBarStart: 161,
        YBarStart: 588,
        xBarGap: 64,
        yOffset: 240,
        conditions: [
            {
                condition: (x) => x >= 9.1,
                score: 3,
                label: 'Optimum',
                image: 'pr3',
            },
            {
                condition: (x) => (3.5 < x) && (x < 9.1),
                score: 2,
                label: 'Slightly below optimum',
                image: 'pr2',
            },
            {
                condition: (x) => x <= 3.5,
                score: 1,
                label: 'Below optimum',
                image: 'pr1',
            }
        ]
    },
    butyrate: {
        page: 40,
        XposText: 503,
        YposText: 707,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 67,
        YposImage: 662,
        xBarStart: 161,
        YBarStart: 712,
        xBarGap: 64,
        yOffset: 280,
        conditions: [
            {
                condition: (x) => x >= 9.45,
                score: 3,
                label: 'Optimum',
                image: 'bu3',
            },
            {
                condition: (x) => (3.75 < x) && (x < 9.45),
                score: 2,
                label: 'Slightly below optimum',
                image: 'bu2',
            },
            {
                condition: (x) => x <= 3.75,
                score: 1,
                label: 'Below optimum',
                image: 'bu1',
            }
        ]
    }
}

const metabolites_spCondition_thai = {
    acetate: {
        page: 39,
        XposText: 515,
        YposText: 445,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 78,
        YposImage: 405,
        xBarStart: 175,
        YBarStart: 455,
        xBarGap: 64,
        yOffset: 200,
        conditions: [
            {
                condition: (x) => x >= 7.35,
                score: 3,
                label: 'เหมาะสม',
                image: 'ac3',
            },
            {
                condition: (x) => (3 < x) && (x < 7.35),
                score: 2,
                label: 'ต่ำกว่าระดับที่เหมาะสมเล็กน้อย',
                image: 'ac2',
            },
            {
                condition: (x) => x <= 3,
                score: 1,
                label: 'ต่ำกว่าระดับที่เหมาะสม',
                image: 'ac1',
            }
        ]
    },
    propionate: {
        page: 39,
        XposText: 515,
        YposText: 579,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 78,
        YposImage: 547,
        xBarStart: 175,
        YBarStart: 589,
        xBarGap: 64,
        yOffset: 240,
        conditions: [
            {
                condition: (x) => x >= 9.1,
                score: 3,
                label: 'เหมาะสม',
                image: 'pr3',
            },
            {
                condition: (x) => (3.5 < x) && (x < 9.1),
                score: 2,
                label: 'ต่ำกว่าระดับที่เหมาะสมเล็กน้อย',
                image: 'pr2',
            },
            {
                condition: (x) => x <= 3.5,
                score: 1,
                label: 'ต่ำกว่าระดับที่เหมาะสม',
                image: 'pr1',
            }
        ]
    },
    butyrate: {
        page: 39,
        XposText: 515,
        YposText: 745,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 78,
        YposImage: 703,
        xBarStart: 175,
        YBarStart: 755,
        xBarGap: 64,
        yOffset: 280,
        conditions: [
            {
                condition: (x) => x >= 9.45,
                score: 3,
                label: 'เหมาะสม',
                image: 'bu3',
            },
            {
                condition: (x) => (3.75 < x) && (x < 9.45),
                score: 2,
                label: 'ต่ำกว่าระดับที่เหมาะสมเล็กน้อย',
                image: 'bu2',
            },
            {
                condition: (x) => x <= 3.75,
                score: 1,
                label: 'ต่ำกว่าระดับที่เหมาะสม',
                image: 'bu1',
            }
        ]
    }
}

export { metabolites_sp, metabolites_multi, metabolites_spCondition, metabolites_spCondition_thai };